module.exports = __webpack_public_path__ + "static/media/Dual_3340.d24f87e6.jpg";